import React from 'react';
import { Tag } from 'antd';
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    ClockCircleOutlined,
    SyncOutlined
} from '@ant-design/icons';

interface StatusBadgeProps {
    status: string;
    showIcon?: boolean;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, showIcon = true }) => {
    const getStatusConfig = (status: string) => {
        switch (status.toUpperCase()) {
            case 'APPROVED':
                return {
                    color: 'success',
                    icon: <CheckCircleOutlined />,
                    text: 'Approved'
                };
            case 'REJECTED':
                return {
                    color: 'error',
                    icon: <CloseCircleOutlined />,
                    text: 'Rejected'
                };
            case 'PENDING':
                return {
                    color: 'warning',
                    icon: <ClockCircleOutlined />,
                    text: 'Pending'
                };
            case 'RETURNED':
                return {
                    color: 'processing',
                    icon: <SyncOutlined spin />,
                    text: 'Returned'
                };
            default:
                return {
                    color: 'default',
                    icon: <ClockCircleOutlined />,
                    text: status
                };
        }
    };

    const config = getStatusConfig(status);

    return (
        <Tag color={config.color} icon={showIcon ? config.icon : null}>
            {config.text}
        </Tag>
    );
};

export default StatusBadge;